package com.partejar.app.core.di

import org.koin.core.context.startKoin
import org.koin.dsl.KoinAppDeclaration

fun initKoin(
    apiBaseUrl: String = PRODUCTION_API_BASE_URL,
    appDeclaration: KoinAppDeclaration = {}
) {
    startKoin {
        appDeclaration()
        modules(
            storageModule,
            platformStorageModule(),
            networkModule(apiBaseUrl),
            repositoryModule,
            viewModelModule
        )
    }
}
